module.exports = __webpack_public_path__ + "img/coupon_tutorial_totolu03.bd24480a.png";